import React from "react";

export function SixDotsIcon() {
  return (
    <svg width="12" height="18" viewBox="0 0 12 18" aria-hidden="true">
      {[3, 9].map((cx) =>
        [4, 9, 14].map((cy) => (
          <circle key={`${cx}-${cy}`} cx={cx} cy={cy} r="1.25" fill="currentColor" />
        )),
      )}
    </svg>
  );
}
